var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.1636C24.8366 32.1636 32 25.0001 32 16.1636C32 7.32702 24.8366 0.163574 16 0.163574C7.16344 0.163574 0 7.32702 0 16.1636C0 25.0001 7.16344 32.1636 16 32.1636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7909 12.1315C24.6883 11.7656 24.4885 11.4343 24.2127 11.1728C23.929 10.9033 23.5814 10.7105 23.2026 10.6127C21.7849 10.239 16.105 10.239 16.105 10.239C13.7371 10.212 11.3698 10.3305 9.01641 10.5938C8.63759 10.6989 8.29062 10.896 8.00635 11.1675C7.72703 11.4363 7.52472 11.7677 7.41903 12.1308C7.16515 13.4985 7.0418 14.8872 7.05064 16.2782C7.04158 17.668 7.16463 19.0563 7.41903 20.4257C7.52245 20.7873 7.72401 21.1172 8.00408 21.3837C8.28415 21.6501 8.63292 21.8426 9.01641 21.9445C10.453 22.3175 16.105 22.3175 16.105 22.3175C18.4759 22.3444 20.8462 22.226 23.2026 21.9627C23.5814 21.8648 23.929 21.672 24.2127 21.4025C24.4884 21.1411 24.688 20.8098 24.7902 20.4438C25.0507 19.0766 25.1774 17.6873 25.1684 16.2956C25.188 14.898 25.0615 13.5021 24.7909 12.1308V12.1315ZM14.2992 18.863V13.6942L19.025 16.279L14.2992 18.863Z",
    fill: "#7536FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4402a5b9ca22075b42c0d290352a4b4c.svg";
export { ForwardRef as ReactComponent };